import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import PersonGroup from "../../../types/PersonGroup"


export interface componentProps {
    item: PersonGroup
}

const ItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.info')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('common.is_enabled')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.isEnabled ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('person-groups.form.default_new_person_add_key')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    {t('common.' + (item.defaultNewPersonAddKey ? 'yes' : 'no'))}
                </IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ItemGroupInfo